import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  Brush,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Bar,
  BarChart,
  Label,
  Cell,
} from 'recharts';
import gradstop from 'gradstop';

import _ from 'lodash';

import { ChannelEventInteractionTable } from '../../Channel/shared/components/ChannelEventInteractionTable';

import { formatDateAndTime } from '../../../../utils/time';

const styles = theme => ({
  interactionStatistics: {
    width: '100%',
    padding: '4px',
    marginTop: '8px',
  },
  paperLineChart: {},
  chartTitle: {
    textAlign: 'center',
    paddingTop: '25px',
    paddingBottom: '10px',
  },
  tableContainer: {
    marginTop: '8px',
  },
  customTooltip: {
    backgroundColor: 'rgba(227, 231, 232, 0.5)',
    padding: '15px',
  },
  customTooltipDate: {
    fontSize: '0.7rem',
  },
  customTooltipDesc: {
    color: '#8884d8',
    paddingTop: '10px',
  },
});

class CustomTooltip extends PureComponent {
  render() {
    const { classes, payload, label } = this.props;
    const date = formatDateAndTime(label * 1000);
    const engagement = _.get(payload, '0.value', null);
    const interaction = _.get(payload, '0.payload.name', null);

    if (engagement && interaction) {
      return (
        <div className={classes.customTooltip}>
          <p className="title">{interaction}</p>
          <p className={classes.customTooltipDate}>{date}</p>
          <p
            className={classes.customTooltipDesc}
          >{`Engagement: ${engagement}%`}</p>
        </div>
      );
    } else {
      return null;
    }
  }
}

const gradient = gradstop({
  stops: 100,
  inputFormat: 'hex',
  colorArray: ['#DAE8F5', '#0B559F'],
});

class EventAnalytics extends React.Component {
  render() {
    let { classes, interactionStatistics } = this.props;

    return (
      <div className={classes.interactionStatistics}>
        <Paper className={classes.paperLineChart}>
          <Typography variant="h6" className={classes.chartTitle}>
            Engaging interactions
          </Typography>
          <ResponsiveContainer width="100%" height={250} id="chartResponsive">
            <BarChart
              data={interactionStatistics}
              margin={{ top: 5, right: 30, left: 20, bottom: 35 }}
            >
              <CartesianGrid strokeDasharray="5 5" />
              <XAxis
                dataKey="publishedAtUnix"
                domain={['dataMin', 'dataMax']}
                tickFormatter={unixTime => formatDateAndTime(unixTime * 1000)}
                type="number"
                scale="time"
                padding={{ left: 20, right: 20 }}
              >
                <Label
                  value={'Time'}
                  position="bottom"
                  style={{ textAnchor: 'middle' }}
                />
              </XAxis>
              <YAxis dataKey="engagement">
                <Label
                  value={'Engagement (%)'}
                  position="left"
                  angle={-90}
                  style={{ textAnchor: 'middle' }}
                />
              </YAxis>
              <Tooltip content={<CustomTooltip classes={classes} />} />
              <Brush
                dataKey="publishedAtUnix"
                height={15}
                stroke="#82ca9d"
                tickFormatter={unixTime => formatDateAndTime(unixTime * 1000)}
                type="number"
                scale="time"
                y={225}
              />
              <Bar
                dataKey="engagement"
                onClick={e => this.props.rowInteractionAction(e)}
                maxBarSize={10}
              >
                {interactionStatistics.map((entry, index) => {
                  return (
                    <Cell
                      fill={gradient[Math.floor(entry.engagement) - 1]}
                      key={`cell-${index}`}
                    />
                  );
                })}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Paper>
        <div className={classes.tableContainer}>
          <ChannelEventInteractionTable
            classes={classes}
            access={'admin'}
            interactionsList={interactionStatistics}
            interactionsPageSize={5}
            isAnalyticsPage={true}
            rowAction={this.props.rowInteractionAction}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(EventAnalytics);
